// The Cloudish wordmark.
//
// Two artworks ship: the colour mark reads on light backgrounds, the white one
// on dark. Which is shown is decided in CSS from the `data-theme` attribute
// rather than in React, so the right one is painted on the very first frame —
// the same reason the theme itself is resolved by an inline script.

export function Logo({ height = 22, className = '' }: { height?: number; className?: string }) {
  // import.meta.env.BASE_URL (Vite's own public-asset base, from vite.config.ts's
  // `base`) rather than a hardcoded leading slash — the embedded build's
  // relative base means a literal "/logo/..." would resolve against the real
  // domain root instead of this container (see embed.ts).
  const base = import.meta.env.BASE_URL;
  return (
    <span className={`logo-mark ${className}`} role="img" aria-label="Cloudish" style={{ height }}>
      <img src={`${base}logo/cloudish.png`} alt="" className="logo-mark-light" style={{ height }} />
      <img src={`${base}logo/cloudish-white.png`} alt="" className="logo-mark-dark" style={{ height }} />
    </span>
  );
}

export default Logo;
